import {
  Box,
  Container,
  Divider,
  Grid,
  Heading,
  Image,
  Stack,
  Text,
  VStack,
} from "@chakra-ui/react";
import { useEffect } from "react";
import { FaRegCirclePlay } from "react-icons/fa6";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import Logo from "../../../assets/colorLogo.png";
import Layout from "../../../components/student/Layout/layout";
import { getAllStudentChaptersRequest } from "../../../modules/students-modules/chapters/Actions";

const ChaptersList = () => {
  const [getSearchParams] = useSearchParams();
  const section_name = getSearchParams.get("name");
  const navigate = useNavigate();
  const { id, type } = useParams();
  const { studentChapters, isLoading } = useSelector(
    (state) => state.studentChapters
  );

  const dispatch = useDispatch();
  useEffect(() => {
    if (id) dispatch(getAllStudentChaptersRequest(id));
  }, [id]);
  return (
    <Layout color="main_1" bg="white" isLoading={isLoading}>
      <Container maxW="container.2xl" h="100%" my="100px" mb="165px" w="100%">
        <VStack spacing={8} h="100%" w="100%" alignItems="flex-start">
          <Heading as="h3" color="main_1" textAlign="center" w="100%">
            {section_name}
          </Heading>
          <Grid
            templateColumns={{ base: "repeat(1, 1fr)", md: "repeat(4, 1fr)" }}
            gap={8}
            w="100%"
          >
            {studentChapters?.map((chapter, index) => {
              return (
                <Box
                  bg="blackAlpha.200"
                  borderRadius={16}
                  display="flex !important"
                  flexDirection="column"
                  onClick={(id, url) => {
                    navigate(`/chapter/${chapter?.id}/${type}`);
                  }}
                  overflow="hidden"
                  role="group"
                  cursor="pointer"
                  _hover={{
                    transition: "500ms ease-in-out",
                  }}
                >
                  <Box overflow="hidden">
                    <Image
                      src={Logo}
                      alt="Green double couch with wooden legs"
                      borderTopRadius="lg"
                      _groupHover={{
                        transform: "scale(1.2)",
                        transition: "500ms ease-in-out",
                      }}
                    />
                  </Box>

                  <Stack spacing="2" p={5} justifyContent="space-between">
                    <Text color="main_1" fontSize={20} fontWeight={600}>
                      {chapter?.name}
                    </Text>
                    {/* <Text color="main_1" fontSize={16}>
                      Arabic
                    </Text> */}
                    <Divider
                      w="100%"
                      colorScheme="green"
                      h="1px"
                      bg="#0100381c"
                    />
                    <Stack flexDirection="row" alignItems="center" gap={1}>
                      <FaRegCirclePlay color="#8196df" size={20} />{" "}
                      <Text mt="-2px !important">
                        {chapter?.videos?.length} lessons
                      </Text>
                    </Stack>
                  </Stack>
                </Box>
              );
            })}
          </Grid>
        </VStack>
      </Container>
    </Layout>
  );
};

export default ChaptersList;
